import { Route, Routes } from "react-router-dom";
import { AccountingAccount } from "./list";

export default function AccountingAccountRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AccountingAccount />} />
      <Route path="/edit" element={<p>Editar Justificaçãoes</p>} />
    </Routes>
  );
}
